module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"action-download":"Herunterladen","action-reload":"Neu laden"},"fr":{"action-download":"Télécharger","action-reload":"Recharger"},"it":{"action-download":"Scaricare","action-reload":"Caricare nuovamente"}}')
  delete Component.options._Ctor
}
